import { useCallback } from 'react';

import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { User } from '@/features/users/types/user';
import { HttpClient, buildEndpointUrl } from '@/libs/axios';
import { MutateReturnOptions } from '@/models/api';
import { getAxiosBackendError } from '@/utils/errors';

export const getCheckCurrentUserMutateKey = () => ['checkCurrentUser'];

export const getCheckCurrentUserEndpoint = () => buildEndpointUrl('USERS', { additionalPaths: ['me'] });

export const apiCheckCurrentUser = async () => await HttpClient.get<User>(getCheckCurrentUserEndpoint());

//

export const useCheckCurrentUser = () => {
    const { mutateAsync, isPending: isChecking } = useMutation<User, AxiosError>({
        mutationKey: getCheckCurrentUserMutateKey(),
        mutationFn: () => apiCheckCurrentUser(),
    });

    const checkCurrentUser = useCallback(
        async ({ onSuccess, onError, onSettled }: MutateReturnOptions<User> = {}) => {
            let response: User;

            try {
                response = await mutateAsync();
            } catch (error: unknown) {
                await onError?.(getAxiosBackendError(error, true));
                await onSettled?.();
                return;
            }

            await onSuccess?.(response);
            await onSettled?.();
        },
        [mutateAsync],
    );

    return { checkCurrentUser, isChecking };
};
